module.exports = __webpack_public_path__ + "img/form-bg.jpg?b46e3ceb62f4fd8079c248537d4a9bb5";